"use client";
import {
  useMenuContext
} from "../__chunks/LG4RFBHV.js";
import "../__chunks/WSQNIDGC.js";
import {
  usePopoverArrow
} from "../__chunks/QS6GU7GL.js";
import "../__chunks/QFL5V2DO.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/CTQR3VDU.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-arrow.tsx
var TagName = "div";
var useMenuArrow = createHook(
  function useMenuArrow2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useMenuContext();
    store = store || context;
    return usePopoverArrow(__spreadValues({ store }, props));
  }
);
var MenuArrow = forwardRef(function MenuArrow2(props) {
  const htmlProps = useMenuArrow(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuArrow,
  useMenuArrow
};
